// extracted by mini-css-extract-plugin
export default {"dashboardButton":"styles_dashboardButton__BiwE6","blue":"styles_blue__Nmrk6","gray":"styles_gray__TfeB+","purple":"styles_purple__tH69D","fit":"styles_fit__2mr83"};